import React, { useEffect, useState } from 'react'
import d from './DownloadPwaButton.module.css'
import {FiDownload} from 'react-icons/fi'


let deferredPrompt;
let PWA_install_state=true;


function DownloadPwaButton() {
  const [installable, setInstallable] = useState(false);

  

  useEffect(() => {
    window.addEventListener("beforeinstallprompt", (e) => {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      // Stash the event so it can be triggered later.
      deferredPrompt = e;
      // Update UI notify the user they can install the PWA
      setInstallable(true);
      PWA_install_state=true;
    });

    window.addEventListener('appinstalled', () => {
      // Log install to analytics
      console.log('INSTALL: Success');
    });
  }, []);




  const handleInstallClick = (e) => {
    // Hide the app provided install promotion
    setInstallable(false);
    PWA_install_state=false;
    // Show the install prompt
    deferredPrompt.prompt();
    // Wait for the user to respond to the prompt
    deferredPrompt.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === 'accepted') {
        console.log('User accepted the install prompt');
      } else {
        console.log('User dismissed the install prompt');
      }
    });
  };

  return (
    <>

      {installable &&
          <button className={d.installButton} onClick={handleInstallClick}>
            Install <FiDownload/>
          </button>
       
      }

    </>
  )
}

 export {PWA_install_state};
export default  DownloadPwaButton